import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const RecentsEmptyStateLoader: LoadableType<{}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-RecentsEmptyState" */
				'../components/RecentsEmptyState.tsx'
			)
		).RecentsEmptyState,
});
